import { DOMUtils } from '../../../../utils/dom'
import { Mixin } from '../../../../utils/mixin'
import { AdBiddingProvider, IAdBiddingAdapter, IAdBiddingProviderConfig } from '../adapter'

export const WithDistrictMBidding = <T extends Mixin<IAdBiddingAdapter>>(Base: T) =>
    class extends Base implements IAdBiddingAdapter {
        private biddingDistrictMJsURL = '//cdn.districtm.ca/merge/light.postmedia.js'

        /**
         * Loads District M JS library.
         */
        public initializeBidding(confs: IAdBiddingProviderConfig[], ...args: any[]) {

            // multiple bidding providers are supported, so fetch conf by name
            const conf = confs.find((_) => _.client === AdBiddingProvider.DISTRICT_M)
            if (conf) {
                DOMUtils.loadScript(`${this.biddingDistrictMJsURL}`)
            }

            super.initializeBidding(confs, ...args)
        }
    }
